<template>
  <div class="comp-main">
    <label>{{ title }}</label>
    <el-input type="search" v-model="searchValue" placeholder="请输入手机号" :maxlength="11" style="margin-right: 8px; width: 16em">
      <template #prefix>
        <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
      </template>
    </el-input>
    <el-button type="primary" @click="submit()" v-loading="loading">查询</el-button>
  </div>
</template>

<script>
import { getFormData } from "@/api/api";
import { getUserInfo } from "@/api/url";
import {phoneReg} from "@/assets/shared/reg-constant";

export default {
  name: "SearchUidOrPhone",
  props: {
    type: {
      type: Number,
      default: 0
    },
    title: {
      type: Object,
      default: '会员充值'
    }
  },
  data() {
    return {
      searchValue: '',
      pageType: this.type,
      loading: false,
    }
  },
  methods: {
    submit() {
      if (!this.searchValue) {
        this.$message({
          message: '请输入手机号',
          duration: 2000,
          type: 'warning'
        })
        return false
      }else if(!phoneReg.test(this.searchValue)) {
        this.$message({
          message: '手机号码格式错误',
          duration: 2000,
          type: 'warning'
        })
        return false
      }
      this.loading = true
      let param = {}
      param['id'] = 0
      param['phone'] = this.searchValue
      getFormData(getUserInfo, param).then((data)=>{
        let {code, msg} = data
        if ( code == 200 ) {
          this.$emit('confirm', data.data)
        } else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.comp-main {
  display: flex;
  align-items: center;
}
.comp-main label {
  white-space: nowrap;
  margin-right: 12px;
}
</style>
